<script>
    import duracion from '../../Utils/duracion';

    export let minutos = 0;
</script>

<span>
    {duracion(minutos)}
</span>